import { Effect, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import { aiTranslateSaga } from './aiTranslate';

const effects: Effect[] = [
  takeEvery(ActionTypes.AI_TRANSLATE, aiTranslateSaga),
];

export default effects;
